import { Button, ButtonProps } from '@chakra-ui/react';
import { FC, ReactNode } from 'react';

import GoogleIcon from '@/assets/icons/google.svg';

import { useAnalytics } from '@/context/Analytics';
import { IdpEntityIds } from '@/enums/IdpEntityIds';
import { StringParam, useQueryParams } from '@/hooks/useQueryParams';
import { getSamlSignInUrl } from '@/utils/redirect';

interface IGoogleSocialSignInButtonProps {
  actionType: 'signUp' | 'login';
  children?: ReactNode;
}

export const GoogleSocialSignInButton: FC<IGoogleSocialSignInButtonProps> = ({ actionType, ...props }) => {
  const analytics = useAnalytics();
  const { redirectUrl } = useQueryParams<{ redirectUrl?: string }>({
    redirectUrl: StringParam,
  });

  const onClick = () => {
    const originURL = encodeURIComponent(`${window.location.origin}${redirectUrl || ''}?login_provider=google`);

    window.open(`${process.env.NEXT_PUBLIC_GOOGLE_SIGN_IN}?origin=${originURL}`, 'targetWindow');

    if (actionType === 'login') {
      analytics.track('user_google_log_in');
    } else {
      analytics.track('user_google_sign_up');
    }
  };

  return (
    <Button
      variant="outline"
      colorScheme="white"
      rightIcon={<GoogleIcon width="24px" height="24px" />}
      onClick={onClick}
      {...props}
    />
  );
};

export const AAPTSocialSignInButton: FC<ButtonProps> = (props) => {
  const onClick = () => {
    window.open(getSamlSignInUrl(IdpEntityIds.AAPT, window.location.origin), 'targetWindow');
  };

  return <Button variant="outline" colorScheme="white" onClick={onClick} {...props} />;
};
